// 支付相关接口
export default {
  ORDER_SWITCH: '/api/order/switch',                              // 新旧支付切换

  ORDER_PRE_INFO: '/api/order/pre/info',                          // 订单预览

  ORDER_ORDER: '/api/order/order',                                // 创建订单

  ORDER_INOF: '/api/order/info',                                  // 订单详情

  PAY_INFO: '/api/order/payInfo',                                 // 支付信息

  ORDER_STATUS: '/api/order/status',                              // 订单状态

  ORDER_REFUND: '/api/order/refund',                              // 退款信息

  ORDER_PRE_REFUND: '/api/order/pre/refund',                      // 退款预览

  ORDER_LIST: '/api/order/list',                                  // 订单列表

  COUPON_LIST: '/api/coupon/list',                                // 优惠券

  INVOICE_SAVE: '/api/order/invoice/open',                        // 开具发票信息保存

  INVOICE_COMPANY: '/api/common/invoice/company/search',          // 开具发票信息抬头查询

  INVOICE_SENDEMADL: '/api/order/invoice/sendmail',               // 发送发票到报名邮箱地址

  SUBMIT_REFUND: '/api/order/submitNcpRefund',                    // 特殊退款申请

  EXCHANGE_COUPONL: '/api/coupon/exchangeCoupon',                 // 兑换优惠券

  INVOICE_INFO: '/api/order/invoice/info',                        // 开具发票信息查询

  JOINT_LIST: '/api/jointCoupon/list',                            // 联名活动列表

  JOINT_LIST_V3: '/api/v3/order/coupon/jointCouponList',                            // 联名活动列表

  JOINT_INFO: '/api/jointCoupon/redirect',                        // 联名活动跳转信息

  INVITATION_STATUS: '/api/coupon/getInvitationCouponCodeStatus',        // 获取是否有推广活动按钮

  INVITATION_CODE: '/api/coupon/getInvitationCouponCode',        // 获取是否有推广活动吗

  REFUND_VALIDATION: '/api/order/refund/validation',                     // 校验是否能退款

  JOINT_EXCHANGE: '/api/jointCoupon/exchange',                     // 领取活动优惠券

  JOINT_EXCHANGE_V3: '/api/v3/order/coupon/jointCoupon/exchange',                     // 领取活动优惠券

  COUPON_PAGE: '/api/coupon/page'       // 优惠券列表

}



// WEBPACK FOOTER //
// ./src/assets/api/constant/payment.js